// axiosInstance.js
import axios from "axios";
import { notification } from "antd";

// ✅ GLOBAL LOCKS (VERY IMPORTANT)
let isHandlingUnauthorized = false;
window.__IS_LOGGING_OUT__ = false;

// ✅ SWITCH BETWEEN LOCAL & LIVE HERE
const BASE_URL =
  // "http://localhost:4002/api"; // ✅ LOCAL DEVELOPMENT
"https://dzi77xykvlyt2.cloudfront.net/api"; // ✅ PRODUCTION

// NOTE: Do NOT set a global Content-Type here because it breaks FormData uploads.
// We'll apply Content-Type conditionally in the request interceptor below.
const axiosInstance = axios.create({
  baseURL: BASE_URL,
  // headers: { "Content-Type": "application/json" }, // removed to allow FormData
});

// ✅ Attach token to every request and set Content-Type conditionally
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // If request body is a FormData (file upload), do NOT set Content-Type here.
    // Let the browser set multipart/form-data with proper boundary.
    const isFormData = config.data instanceof FormData;
    if (!isFormData) {
      // For normal requests set JSON content-type (keeps previous behavior).
      config.headers["Content-Type"] = "application/json";
    } else {
      // Ensure any leftover content-type is removed for FormData requests
      if (config.headers && config.headers["Content-Type"]) {
        delete config.headers["Content-Type"];
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ ✅ FINAL RESPONSE INTERCEPTOR (SPAM-PROOF)
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const excludedEndpoints = [
      "/auth/user/login",
      "/auth/user/register",
      "/auth/user/forgot-password",
      "/auth/user/reset-password",
    ];

    const isExcludedEndpoint = excludedEndpoints.some((endpoint) =>
      error.config?.url?.includes(endpoint)
    );

    if (isExcludedEndpoint) {
      return Promise.reject(error);
    }

    // ✅ HANDLE SESSION EXPIRY ONLY ONCE
    if (error.response?.status === 401 && !isHandlingUnauthorized) {
      isHandlingUnauthorized = true;
      window.__IS_LOGGING_OUT__ = true; // ✅ SILENT MODE FOR ALL SCREENS

      // ✅ CLEAR ALL EXISTING POPUPS
      notification.destroy();

      // ✅ SHOW ONLY ONE MESSAGE
      notification.error({
        message: "Session Expired",
        description: "Your session has expired. Please log in again.",
        placement: "topRight",
        duration: 2,
      });

      // ✅ FULL CLEAR (HARDCODE SAFE)
      localStorage.clear();
      axiosInstance.defaults.headers.Authorization = "";

      // ✅ IMMEDIATE REDIRECT (NO DELAY)
      window.location.replace("/login");
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
